import { useState, useRef } from "react"
import { Mail } from "../assets/images/image"
import ReCAPTCHA from "react-google-recaptcha"
import { useScrollToSection } from "../hooks/ScrollContext"
import { API_URL, RECAPTCHA_KEY } from "../configs/default.config"
const Contact = () => {
    const { scrollToSection } = useScrollToSection();
    const [loading, setLoading] = useState(false);
    const [popupMessage, setPopupMessage] = useState<string | null>(null);
    const [formValues, setFormValues] = useState({
        fullName: "",
        email: "",
        message: "",
        subject: "",
    })
    const recaptchaRef = useRef<ReCAPTCHA | null>(null);
    const [captchaToken, setCaptchaToken] = useState<string | null>(null);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target
        setFormValues((prev) => ({ ...prev, [name]: value }))
    }
    const handleSubmtit = async () => {
        if (!captchaToken) {
            alert("Please complete the CAPTCHA.");
            return;
        }
        setLoading(true);
        try {
            const response = await fetch(API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ...formValues,
                    recaptchaToken: captchaToken,
                }),
            });

            if (!response.ok) throw new Error("Failed to send message.");
            setPopupMessage("Your message has been sent successfully!");
            setFormValues({ fullName: "", email: "", message: "", subject: "" });
            recaptchaRef.current?.reset();
            setCaptchaToken(null);
        } catch (error) {
            setPopupMessage("Something went wrong. Please try again.");

        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="w-full h-full">
            <div className="hidden md:flex items-start h-full">
                <div className="w-full h-full relative space-y-8">
                    {popupMessage && (
                        <div className="fixed bottom-10 right-4 bg-[#FFD600] text-[#212224] font-bold px-6 py-3 rounded-2xl shadow-lg z-50">
                            {popupMessage}
                            <button className="ml-4 text-sm underline" onClick={() => setPopupMessage(null)}>Close</button>
                        </div>
                    )}
                    <div className="space-y-8 w-[60%] mx-auto">
                        <div className="space-y-2">
                            <p className="text-[48px] font-light text-[#484848] font-inter" data-reveal="up">Contact Us</p>
                            <p className="text-[24px] font-bold text-[#484848] font-inter" data-reveal="up">Reach out to our team</p>
                        </div>
                        <div className="w-full grid grid-cols-2 gap-x-9 gap-y-8" data-reveal="up">
                            <div className="col-span-1 space-y-4">
                                <p className="font-inter text-[17px] font-bold text-[#484848]">Your Name <span className="text-[14px] font-light text-[#EF403B]"> (Required)</span></p>
                                <input onChange={(e) => { handleChange(e) }} value={formValues.fullName} name="fullName" className="w-full rounded-lg bg-[#EDEDED] border outline-none focus:border-[#FFD600] h-[77px] text-[17px] font-inter font-bold px-4 focus:caret-[#FFD600]" />
                            </div>
                            <div className="col-span-1 space-y-4">
                                <p className="font-inter text-[17px] font-bold text-[#484848]">Your Email <span className="text-[14px] font-light text-[#EF403B]"> (Required)</span></p>
                                <input onChange={(e) => { handleChange(e) }} value={formValues.email} name="email" className="w-full rounded-lg bg-[#EDEDED] border outline-none focus:border-[#FFD600] h-[77px] text-[17px] font-inter font-bold px-4 focus:caret-[#FFD600]" />
                            </div>
                            <div className="col-span-1 space-y-8">
                                <div className="space-y-4">
                                    <p className="font-inter text-[17px] font-bold text-[#484848]">Subject <span className="text-[14px] font-light text-[#484848]"> (Optional, but recommended)</span></p>
                                    <input onChange={(e) => { handleChange(e) }} value={formValues.subject} name="subject" className="w-full rounded-lg bg-[#EDEDED] border outline-none focus:border-[#FFD600] h-[77px] text-[17px] font-inter font-bold px-4 focus:caret-[#FFD600]" />
                                </div>
                                <div className="flex items-center justify-end">
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        sitekey={RECAPTCHA_KEY}
                                        onChange={(token) => setCaptchaToken(token)}
                                        onExpired={() => setCaptchaToken(null)}
                                    />
                                </div>
                                <div className="flex items-center justify-end">
                                    <div className="cursor-pointer w-[343px] h-14 flex items-center justify-center gap-x-2 rounded-lg bg-[#FFD600] border border-[#D9D9D9]" onClick={() => { handleSubmtit() }}>
                                        <img src={Mail} alt="Mail" className="w-[24px] h-[24px]" />
                                        <p className="text-[14px] font-inter text-[#484848]">{loading ? "Sending..." : "Submit"}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-span-1 space-y-4">
                                <p className="font-inter text-[17px] font-bold text-[#484848]">Message <span className="text-[14px] font-light text-[#EF403B]"> (Required)</span></p>
                                <textarea onChange={(e) => { handleChange(e) }} value={formValues.message} name="message" className="w-full min-h-[200px] rounded-lg bg-[#EDEDED] border outline-none focus:border-[#FFD600] h-[77px] text-[17px] font-inter font-bold p-4 focus:caret-[#FFD600]" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col items-center gap-y-10 px-4 pt-6 md:hidden">
                <div className="w-full flex items-start">
                    <div className="flex items-center w-full">
                        <span
                            className="text-[17px] font-normal font-inter text-[#484848] cursor-pointer hover:underline bg-[#D9D9D9] me-6 pt-[4px] pb-[4px] ps-[8px] pe-[8px] rounded-[16px]"
                            onClick={() => scrollToSection("home")}
                        >
                            Home
                        </span>
                        <div className="bg-[#FFD600] me-6 pt-[4px] pb-[4px] ps-[8px] pe-[8px] rounded-[16px]">
                            <span className="text-[17px] font-normal font-inter text-[#484848] mx-2">→</span>
                            <span className="text-[17px] font-bold font-inter text-[#484848]">
                                Contact
                            </span>
                        </div>
                    </div>
                </div>
                <div className="space-y-2 text-center">
                    <p className="text-[24px] font-light text-[#484848] font-inter" data-reveal="up">Contact Us</p>
                    <p className="text-[14px] font-bold text-[#484848] font-inter" data-reveal="up">Reach out to our team</p>
                </div>
                <div className="w-full grid grid-cols-1 gap-x-9 gap-y-8" data-reveal="up">
                    <div className="col-span-1 space-y-4">
                        <p className="font-inter text-[17px] font-bold text-[#484848]">Your Name <span className="text-[14px] font-light text-[#EF403B]"> (Required)</span></p>
                        <input onChange={(e) => { handleChange(e) }} value={formValues.fullName} name="fullName" className="w-full rounded-lg bg-[#EDEDED] border outline-none focus:border-[#FFD600] h-[77px] text-[17px] font-inter font-bold px-4 focus:caret-[#FFD600]" />
                    </div>
                    <div className="col-span-1 space-y-4">
                        <p className="font-inter text-[17px] font-bold text-[#484848]">Your Email <span className="text-[14px] font-light text-[#EF403B]"> (Required)</span></p>
                        <input onChange={(e) => { handleChange(e) }} value={formValues.email} name="email" className="w-full rounded-lg bg-[#EDEDED] border outline-none focus:border-[#FFD600] h-[77px] text-[17px] font-inter font-bold px-4 focus:caret-[#FFD600]" />
                    </div>
                    <div className="col-span-1 space-y-4">
                        <p className="font-inter text-[17px] font-bold text-[#484848]">Subject <span className="text-[14px] font-light text-[#484848]"> (Optional, but recommended)</span></p>
                        <input onChange={(e) => { handleChange(e) }} value={formValues.subject} name="subject" className="w-full rounded-lg bg-[#EDEDED] border outline-none focus:border-[#FFD600] h-[77px] text-[17px] font-inter font-bold px-4 focus:caret-[#FFD600]" />
                    </div>
                    <div className="col-span-1 space-y-4">
                        <div className="space-y-4">
                            <p className="font-inter text-[17px] font-bold text-[#484848]">Message <span className="text-[14px] font-light text-[#EF403B]"> (Required)</span></p>
                            <textarea onChange={(e) => { handleChange(e) }} value={formValues.message} name="message" className="w-full min-h-[200px] rounded-lg bg-[#EDEDED] border outline-none focus:border-[#FFD600] h-[77px] text-[17px] font-inter font-bold p-4 focus:caret-[#FFD600]" />
                        </div>
                        <div className="flex items-center justify-start">
                            <ReCAPTCHA
                                className="w-full"
                                ref={recaptchaRef}
                                sitekey={RECAPTCHA_KEY}
                                onChange={(token) => setCaptchaToken(token)}
                                onExpired={() => setCaptchaToken(null)}
                            />
                        </div>
                        <div className="flex items-center justify-end">
                            <div className="cursor-pointer w-full h-14 flex items-center justify-center gap-x-2 rounded-lg bg-[#FFD600] border border-[#D9D9D9]" onClick={() => { handleSubmtit() }}>
                                <img src={Mail} alt="Mail" className="w-[24px] h-[24px]" />
                                <p className="text-[14px] font-inter text-[#484848]">{loading ? "Sending..." : "Submit"}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Contact